module.exports = __webpack_public_path__ + "static/media/88gal03.026d4abe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/88gal/88gal03.jpg
// module id = 217
// module chunks = 0